import useData from "./useData";
import config from "../../config/apiService.json";
import getPaginatePageItems from "../../utils/getPaginatePageItems";

const useServices = (pagination = false) => {
  const { home } = config;
  const { services } = home;
  const itemsPerPage = 4;
  const { data, isLoading } = useData(services);
  if (pagination) {
    const paginatedItems = getPaginatePageItems(data, itemsPerPage);
    return { data: paginatedItems, isLoading };
  }
  return { data, isLoading };
};
export default useServices;
